import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import { Alert, Table, Button, Container, Form, Pagination, Spinner } from 'react-bootstrap';

// HINZUGEFÜGT: Import unserer zentralen Konfigurationen
import { rentedBatchesColumns } from '../config/tableColumns'; 
import { formatDate } from '../utils/formatters'; // Import der zentralen Formatierungsfunktion

const RentedBatchesManager = () => { // Umbenannt für mehr Klarheit
  const [batchOrders, setBatchOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('order_id');
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    loadRentedBatches();
  }, [currentPage, searchTerm, sortField, sortOrder]);

  // KORRIGIERT: Ruft die neue Backend-Route über einen neuen Service auf
  const loadRentedBatches = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      // Annahme: Es gibt eine neue Funktion im UserService
      const response = await UserService.getAllRentedBatches({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder
      });
      setBatchOrders(response.data.batchOrders);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setApiErrors("Fehler beim Laden der kommissionierten Chargen: " + resMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (field) => {
    if (!field.sortable) return; // Nicht sortieren, wenn nicht erlaubt
    const newSortOrder = sortField === field.key && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field.key);
    setSortOrder(newSortOrder);
  };

  const handleRevertRenting = async (order) => {
    // Diese Funktion bleibt vorerst unverändert
    alert("Funktion 'Miete zurücksetzen' für Bestellnummer " + order.order_id + " noch nicht implementiert.");
  };

  return (
    <Container style={{ paddingTop: '20px' }}>
      <h1>Kommissionierte Chargen</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
     
      <Form.Group controlId="search" className="mb-3">
        <Form.Control
          type="text"
          placeholder="Suchen..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={{ maxWidth: '300px' }}
        />
      </Form.Group>

      {loading && <div className="text-center"><Spinner animation="border" /></div>}

      <Table striped bordered hover responsive>
        {/* HIER PASSIERT DIE MAGIE: Der Tabellenkopf wird dynamisch erstellt */}
        <thead>
          <tr>
            {rentedBatchesColumns.map(col => (
              <th key={col.key} onClick={() => handleSortChange(col)} style={{ cursor: col.sortable ? 'pointer' : 'default' }}>
                {col.header}
              </th>
            ))}
            <th>Aktionen</th>
          </tr>
        </thead>
        {/* HIER PASSIERT DIE MAGIE: Der Tabellenkörper wird dynamisch erstellt */}
        <tbody>
          {batchOrders.map(order => (
            <tr key={order.order_id}>
              {rentedBatchesColumns.map(col => (
                <td key={col.key}>
                  {/* Die Render-Logik aus der Konfigurationsdatei wird hier verwendet */}
                  {col.render ? col.render(order) : (order[col.key] || 'N/A')}
                </td>
              ))}
              <td>
                <Button 
                  variant="danger" 
                  size="sm"
                  onClick={() => handleRevertRenting(order)}
                >
                  Stornieren
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination style={{ marginTop: '20px', justifyContent: 'center' }}>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </Container>
  );
};

export default RentedBatchesManager;